import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import AccessibleIcon from '../AccessibleIcon'
import iconHyperlinkStyles, { linkSize, linkTheme, badgeSize, badgeTheme, iconSize, iconTheme } from '../IconHyperlink/styles'

import styles from './styles'

const IconButtonLink = ({ theme, size, className, icon, withBackground, label, disabled, ...props }) => (
  <button
    className={cx(
      styles.button,
      iconHyperlinkStyles.link,
      linkSize(size),
      linkTheme(theme, withBackground),
      disabled && iconHyperlinkStyles.disabled,
      className,
    )}
    type="button"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}>
    <span className={cx(iconHyperlinkStyles.badge, withBackground && [badgeTheme(theme), badgeSize(size)])}>
      <AccessibleIcon icon={icon} size={iconSize(size)} color={iconTheme(theme)} />
    </span>
    <span>{label}</span>
  </button>
)

IconButtonLink.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  withBackground: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small', 'medium']),
  disabled: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
}

IconButtonLink.defaultProps = {
  theme: 'primary',
  size: 'default',
  withBackground: true,
}

export default IconButtonLink
